module.exports = __webpack_public_path__ + "static/media/elo.68233a74.svg";